/* HRH custom behaviors: free-gift-with-purchase, toasts, newsletter popup. */
(function () {
  'use strict';

  var cfg = window.hrhConfig || {};

  /* ---------- Toasts ---------- */
  function toast(message) {
    var region = document.querySelector('.hrh-toast-region');
    if (!region) {
      region = document.createElement('div');
      region.className = 'hrh-toast-region';
      region.setAttribute('aria-live', 'polite');
      document.body.appendChild(region);
    }
    var el = document.createElement('div');
    el.className = 'hrh-toast';
    el.textContent = message;
    region.appendChild(el);
    requestAnimationFrame(function () {
      el.classList.add('is-visible');
    });
    setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () {
        el.remove();
      }, 400);
    }, 3500);
  }

  /* ---------- Cart drawer refresh (after programmatic cart changes) ---------- */
  function refreshCartUI() {
    return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) {
        return r.json();
      })
      .then(function (sections) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && sections['cart-drawer']) {
          var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          var fresh = doc.querySelector('.drawer__inner');
          var current = drawer.querySelector('.drawer__inner');
          if (fresh && current) current.replaceWith(fresh);
          var freshDrawer = doc.querySelector('cart-drawer');
          if (freshDrawer && freshDrawer.classList.contains('is-empty')) {
            drawer.classList.add('is-empty');
          } else {
            drawer.classList.remove('is-empty');
          }
        }
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && sections['cart-icon-bubble']) {
          var bdoc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
          var freshBubble = bdoc.getElementById('shopify-section-cart-icon-bubble');
          if (freshBubble) bubble.innerHTML = freshBubble.innerHTML;
        }
      })
      .catch(function () {});
  }

  /* ---------- Free gift with purchase ---------- */
  var gwpBusy = false;

  function checkGift() {
    if (!cfg.gwpEnabled || !cfg.gwpVariantId || !cfg.gwpThreshold || gwpBusy) return;
    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var giftLine = null;
        var subtotalExGift = 0;
        cart.items.forEach(function (item) {
          if (
            String(item.variant_id) === String(cfg.gwpVariantId) &&
            item.properties &&
            item.properties._hrh_free_gift
          ) {
            giftLine = item;
          } else {
            subtotalExGift += item.final_line_price;
          }
        });
        var qualifies = subtotalExGift >= cfg.gwpThreshold * 100;

        if (qualifies && !giftLine) {
          gwpBusy = true;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: Number(cfg.gwpVariantId),
              quantity: 1,
              properties: { _hrh_free_gift: '1' },
            }),
          })
            .then(function (r) {
              if (!r.ok) throw new Error('add failed');
              toast(cfg.gwpAddedText || 'You unlocked a free gift');
              return refreshCartUI();
            })
            .catch(function () {})
            .finally(function () {
              gwpBusy = false;
            });
        } else if (!qualifies && giftLine) {
          gwpBusy = true;
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: giftLine.key, quantity: 0 }),
          })
            .then(function (r) {
              if (!r.ok) throw new Error('change failed');
              toast(cfg.gwpRemovedText || 'Your cart no longer qualifies for the free gift');
              return refreshCartUI();
            })
            .catch(function () {})
            .finally(function () {
              gwpBusy = false;
            });
        }
      })
      .catch(function () {});
  }

  // Re-check whenever any cart endpoint is hit anywhere in the theme.
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
    var isCartMutation = /\/cart\/(add|change|update|clear)/.test(url);
    var result = origFetch.apply(this, arguments);
    if (isCartMutation) {
      result.finally(function () {
        setTimeout(checkGift, 300);
      });
    }
    return result;
  };
  document.addEventListener('DOMContentLoaded', checkGift);

  /* ---------- Newsletter popup ---------- */
  function initPopup() {
    var popup = document.getElementById('HrhPopup');
    if (!popup) return;

    function open() {
      popup.setAttribute('open', '');
      document.documentElement.style.overflow = 'hidden';
    }
    function close() {
      popup.removeAttribute('open');
      document.documentElement.style.overflow = '';
      try {
        localStorage.setItem('hrh_popup_dismissed', String(Date.now()));
      } catch (e) {}
    }

    popup.querySelectorAll('[data-hrh-popup-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.hasAttribute('open')) close();
    });

    // After a successful signup Shopify reloads with ?customer_posted=true.
    if (window.location.search.indexOf('customer_posted=true') !== -1) {
      open();
      return;
    }

    if (window.Shopify && window.Shopify.designMode) return;

    var dismissed = 0;
    try {
      dismissed = Number(localStorage.getItem('hrh_popup_dismissed') || 0);
    } catch (e) {}
    var thirtyDays = 30 * 24 * 60 * 60 * 1000;
    if (dismissed && Date.now() - dismissed < thirtyDays) return;

    setTimeout(open, (cfg.popupDelay || 6) * 1000);
  }
  document.addEventListener('DOMContentLoaded', initPopup);
})();

/* ---------- Card image carousel (scroll-snap + range scrubber + hover-to-second-image) ---------- */
(function () {
  'use strict';

  function fineHover() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }
  function coarsePointer() {
    return window.matchMedia('(hover: none), (pointer: coarse)').matches;
  }
  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  if (window.customElements && !customElements.get('hrh-card-carousel')) {
    customElements.define(
      'hrh-card-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-hrh-track]');
          this.range = this.querySelector('[data-hrh-range]');
          if (!this.track || this.inited) return;
          this.inited = true;
          this.index = 0;
          this.total = this.track.children.length;
          var self = this;

          function behavior() {
            return reducedMotion() ? 'auto' : 'smooth';
          }
          function goTo(i, b) {
            self.index = Math.min(Math.max(i, 0), self.total - 1);
            var w = self.track.clientWidth || 1;
            self.programmatic = true;
            self.track.scrollTo({ left: self.index * w, behavior: b || behavior() });
            if (self.range) self.range.value = String(self.index);
            clearTimeout(self.progTimer);
            self.progTimer = setTimeout(function () {
              self.programmatic = false;
            }, 500);
          }

          this.track.addEventListener(
            'scroll',
            function () {
              if (self.programmatic) return;
              var w = self.track.clientWidth || 1;
              var idx = Math.round(self.track.scrollLeft / w);
              self.index = Math.min(Math.max(idx, 0), self.total - 1);
              if (self.range && String(self.index) !== self.range.value) self.range.value = String(self.index);
            },
            { passive: true }
          );

          if (this.range) {
            this.range.addEventListener('input', function () {
              goTo(Number(self.range.value), 'auto');
            });
            this.range.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation();
            });
          }

          // Desktop: hovering the card slides to the second photo, back on leave.
          // Dawn stretches the title link over the whole card, so pointer events
          // never reach this element directly — listen on the card wrapper.
          var cardWrapper = this.closest('.card-wrapper') || this;
          cardWrapper.addEventListener('pointerenter', function () {
            if (fineHover() && self.total > 1) goTo(1);
          });
          cardWrapper.addEventListener('pointerleave', function () {
            if (fineHover()) goTo(0);
          });

          // Mobile: first tap on the image reveals the second photo instead of
          // navigating (hit-test the tap against the carousel's box).
          cardWrapper.addEventListener('click', function (e) {
            if (!coarsePointer() || self.total < 2 || self.index !== 0) return;
            if (!e.target.closest('a[href]')) return;
            var r = self.getBoundingClientRect();
            if (e.clientY >= r.top && e.clientY <= r.bottom && e.clientX >= r.left && e.clientX <= r.right) {
              e.preventDefault();
              goTo(1);
            }
          });

          this.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowLeft') goTo(self.index - 1);
            if (e.key === 'ArrowRight') goTo(self.index + 1);
          });

          window.addEventListener('resize', function () {
            goTo(self.index, 'auto');
          });
        }
      }
    );
  }
})();

/* ---------- Mobile swipe-hint arrows on carousels ---------- */
(function () {
  'use strict';
  function initHints() {
    if (!window.matchMedia('(max-width: 989px)').matches) return;
    document.querySelectorAll('slider-component').forEach(function (sc) {
      if (sc.dataset.hrhHint) return;
      if (sc.closest('.product__media-wrapper')) return; // gallery has its own controls
      var slider = sc.querySelector('ul.slider, .slider');
      var next = sc.querySelector('button[name="next"]');
      if (!slider || !next) return;
      if (slider.scrollWidth <= slider.clientWidth + 10) return; // nothing to swipe
      sc.dataset.hrhHint = '1';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'hrh-swipe-hint';
      btn.setAttribute('aria-label', 'Next');
      btn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var slide = slider.querySelector('li, .slider__slide');
        var step = slide ? slide.getBoundingClientRect().width : slider.clientWidth * 0.8;
        slider.scrollBy({ left: step, behavior: 'smooth' });
      });
      sc.appendChild(btn);
      var sync = function () {
        btn.hidden = next.disabled ||
          slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 10;
      };
      slider.addEventListener('scroll', sync, { passive: true });
      sync();
    });
  }
  document.addEventListener('DOMContentLoaded', initHints);
  window.addEventListener('resize', initHints);
})();

/* ---------- Branded subscribe-confirmation page (/account/subscribe) ---------- */
(function () {
  'use strict';
  if (window.location.pathname.indexOf('/account/subscribe') !== 0) return;
  document.addEventListener('DOMContentLoaded', function () {
    var main = document.getElementById('MainContent');
    if (!main) return;
    var unsub = main.querySelector('a[href*="unsubscribe"], a');
    var unsubHref = unsub ? unsub.getAttribute('href') : null;
    main.innerHTML =
      '<div class="hrh-welcome">' +
      '<p class="hrh-welcome__eyebrow">HRH Secret Society</p>' +
      '<h1 class="hrh-welcome__heading">Welcome to the <em>Secret Society</em></h1>' +
      '<p class="hrh-welcome__text">You’re in. Here’s your 10% welcome code — it’s yours for your first order:</p>' +
      '<button type="button" class="hrh-welcome__code" data-code="SOCIETY10">SOCIETY10<span>tap to copy</span></button>' +
      '<div class="hrh-welcome__ctas">' +
      '<a class="button" href="/collections/best-sellers-1">Shop best sellers</a>' +
      '<a class="button button--secondary" href="/collections/all-products">Shop all</a>' +
      '</div>' +
      (unsubHref ? '<a class="hrh-welcome__unsub" href="' + unsubHref + '">Unsubscribe</a>' : '') +
      '</div>';
    var codeBtn = main.querySelector('.hrh-welcome__code');
    codeBtn.addEventListener('click', function () {
      try {
        navigator.clipboard.writeText('SOCIETY10');
        codeBtn.querySelector('span').textContent = 'copied ✓';
      } catch (e) {}
    });
  });
})();

/* HRH — desktop mega menu: open on hover, parent title click navigates (2026-10-18) */
(function () {
  var mq = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
  if (!mq.matches) return;
  var menus = document.querySelectorAll('header-menu');
  if (!menus.length) return;
  menus.forEach(function (hm) {
    var details = hm.querySelector('details');
    if (!details) return;
    var timer;
    hm.addEventListener('mouseenter', function () {
      clearTimeout(timer);
      document.querySelectorAll('header-menu details[open]').forEach(function (d) { if (d !== details) d.open = false; });
      details.open = true;
    });
    hm.addEventListener('mouseleave', function () {
      timer = setTimeout(function () { details.open = false; }, 180);
    });
    var title = hm.querySelector('summary .hrh-menu-parent-title');
    if (title) title.addEventListener('click', function (e) { e.stopPropagation(); });
  });
})();
